import React, {Component} from 'react';
import {
  Card,
  CardBody,
  Row,
  Col,
  Form,
  CardTitle, Table,
} from 'reactstrap';
import {Form as FinalForm} from 'react-final-form';
import TextField from '../components/TextField';
import FileField from '../components/FileField';
import {Colxx, Separator} from '../components/common/CustomBootstrap';
import {NotificationManager} from '../components/common/react-notifications';
import LoaderButton from '../components/LoaderButton';
import {difference, dataURItoBlob, getStatusColor} from '../helpers/Utils';
import {forEach, isEmpty, reduce, map, flattenDeep, keyBy, mapValues} from 'lodash';
import ModalManager from "../components/modal/ModalManager";
import {BigPlayButton, Player} from "video-react";
import {withTranslation} from 'react-i18next';
import Zoom from "react-medium-image-zoom";
import Rbac from '../components/Rbac';
import Api from '../services/Api';

class KycSection extends Component {
  constructor(props) {
    super(props);
    const {kycInfo, level, kycItems} = props;
    const {kycItemsInfo} = kycInfo;
    this.state = {
      info: {...kycInfo}
    };
    this.levelItems = map(flattenDeep(level.items), name => {
      return {
        name,
        type: kycItems[name].type,
        subItems: kycItems[name].subItems ? kycItems[name].subItems : [name],
        ...kycItemsInfo[name],
      };
    });
    this.itemTypes = reduce(kycItems, function(result, value, key) {
      return {
        ...result,
        ...(value.subItems ?
          mapValues(keyBy(map(value.subItems, item => ({name: item})), 'name'), () => value.type)
          :
          {[key]: value.type}),
      };
    }, {});
  }

  updateInfo = async values => {
    const {info} = this.state;
    const {t, userId} = this.props;
    const formData = new FormData();
    formData.append('userId', userId);
    const diff = difference(values, info);
    try {
      if (!isEmpty(diff)) {
        forEach(diff, (value, key) => {
          if (this.itemTypes[key] === 'image' || this.itemTypes[key] === 'video') {
            formData.append(key, dataURItoBlob(value));
          } else {
            formData.append(key, value);
          }
        });
        const response = await Api.invoke('PATCH', '/admin-ui/user-kyc-info', formData);
        this.setState({
          info: {
            ...this.state.info,
            ...response.data,
          },
        });
      } else {
        NotificationManager.warning(t('Stats has not be changed'), t('Message'));
      }
    } catch (e) {
      if (e.fieldError) {
        return e.fieldError;
      }
      throw e;
    }
  };

  getImages = subItems => {
    const {info} = this.state;
    const {t} = this.props;
    let images = [];
    forEach(subItems, (value, index) => {
      if (info[value]) {
        images = [
          ...images,
          <div key={index}>
            {info[value].split(",").map(item => (
              <img
                key={item}
                onClick={() => {
                  ModalManager.open({
                    size: 'lg',
                    isOpen: true,
                    title: t(value),
                    body: <Zoom><img src={item} width="100%" height="100%"/></Zoom>,
                  });
                }}
                className='mr-2 cursor-pointer'
                src={item}
                height={40}
                width={40}
              />
            ))}
          </div>
        ];
      }
    });
    return images;
  };

  getVideos = (subItems) => {
    const {info} = this.state;
    const {t} = this.props;
    let videos = [];
    forEach(subItems, (value, index) => {
      if (info[value]) {
        videos = [
          ...videos,
          <div key={index}>
            <img
              onClick={() => {
                ModalManager.open({
                  size: 'lg',
                  isOpen: true,
                  title: t(value),
                  body: <Player>
                    <BigPlayButton position="center" />
                    <source src={info[value]} />
                  </Player>,
                });
              }}
              className='mr-2 cursor-pointer'
              src="/assets/img/player.svg"
              height={40}
              width={40}
            />
          </div>
        ];
      }
    });
    return videos;
  };

  render() {
    const {info} = this.state;
    const {t, level} = this.props;
    return (
      <Row>
        <Colxx xxs="12" className="mb-4">
          <Card className="h-100">
            <CardBody>
              <CardTitle className="text-large text-primary">
                {`${t('Identity Authentication')} (${t('level')} ${level.level})`}
              </CardTitle>
              <FinalForm onSubmit={this.updateInfo}
               render={({handleSubmit, submitting}) => {
                 return (
                   <Form onSubmit={handleSubmit}>
                     {this.levelItems.filter(item => (item.name !== "PHONE_NUMBER" && item.name !== "BANK_CARD_NUMBER")).map((item) => {
                       const {subItems, type, name, status, feedback, evaluatorFirstName, evaluatorLastName, evaluatorUsername} = item;
                       return (
                         <div key={name}>
                           <Row>
                             <Col>
                               {subItems.map((subItem) => {
                                 return (
                                   <div key={subItem}>
                                     {type === 'image' ?
                                       <FileField
                                         item={{
                                           name: subItem,
                                           i18n: t(subItem),
                                           path: info[subItem],
                                           accept: 'image/png,image/jpeg',
                                           disabled: !Rbac.hasPermission('update_user-kyc'),
                                           withoutPreview: true,
                                         }}
                                       />
                                       : type === "video" ?
                                         <FileField
                                           item={{
                                             name: subItem,
                                             i18n: t(subItem),
                                             path: info[subItem],
                                             accept: 'video/mp4',
                                             disabled: !Rbac.hasPermission('update_user-kyc'),
                                             withoutPreview: true,
                                           }}
                                         /> :
                                         <TextField
                                           item={{
                                             name: subItem,
                                             i18n: t(subItem),
                                             value: info[subItem],
                                             type: 'textarea',
                                             disabled: !Rbac.hasPermission('update_user-kyc'),
                                           }}
                                         />
                                     }
                                   </div>
                                 );
                               })}
                             </Col>
                             <Col>
                               <Table bordered responsive style={{marginTop: 20}}>
                                 <tbody>
                                 {!!status && <tr>
                                   <td style={{width: 130}} className="text-info">{t('Status')}</td>
                                   <td className={getStatusColor(status)}>{t(status)}</td>
                                 </tr>}
                                 {!!evaluatorUsername && <tr>
                                   <td style={{width: 130}} className="text-info">{t('Evaluated By')}</td>
                                   <td>{`${evaluatorFirstName ? `${evaluatorFirstName} ${evaluatorLastName} ` : ''}[${evaluatorUsername}]`}</td>
                                 </tr>}
                                 {!!feedback && <tr>
                                   <td style={{width: 130}} className="text-info">{t('Feedback')}</td>
                                   <td>{feedback}</td>
                                 </tr>}
                                 {type === 'image' && this.getImages(subItems).length > 0 && <tr>
                                   <td style={{width: 130}} className="text-info">{t('Images')}</td>
                                   <td className='d-flex flex-row align-items-center'>
                                     {this.getImages(subItems)}
                                   </td>
                                 </tr>}
                                 {type === 'video' && this.getVideos(subItems).length > 0 && <tr>
                                   <td style={{width: 130}} className="text-info">{t('Video')}</td>
                                   <td className='d-flex flex-row align-items-center'>
                                     {this.getVideos(subItems)}
                                   </td>
                                 </tr>}
                                 </tbody>
                               </Table>
                             </Col>
                           </Row>
                           <Separator className='my-4'/>
                         </div>
                       );
                     })}
                     <Rbac permission='update_user-kyc'>
                       <LoaderButton
                         loading={submitting}
                         onClick={handleSubmit}
                         disabled={submitting}
                         className="my-2 text-center"
                         style={{minWidth: '100px'}}>
                         {t('Save')}
                       </LoaderButton>
                     </Rbac>
                   </Form>
                 );
               }}
              />
            </CardBody>
          </Card>
        </Colxx>
      </Row>
    );
  }
}

export default withTranslation()(KycSection);
